import React from 'react'
import {
  StyledNavbarGroup,
  StyledNavbarGroupRight,
  StyledSeparator,
} from './Navbar.styled'
import IconButton from '../IconButton/IconButton'
import RoutingEnum from '../../routes/appRoutes'
import pxToRem from '../../utils/pxToRem'
import { IconTypeEnum } from '../../theme/icons'
import SearchIcon from '../../images/icons/search.svg'
import ContactIcon from '../../images/icons/contact.svg'
import BurgerMenu from '../BurgerMenu/BurgerMenu'

const NavBarMobile = () => {
  return (
    <>
      <StyledNavbarGroup>
        <IconButton
          ariaLabel={'search'}
          to={RoutingEnum.search}
          height={pxToRem(24)}
          width={pxToRem(24)}
          type={IconTypeEnum.search}
        >
          <SearchIcon />
        </IconButton>
        <IconButton
          ariaLabel={'contact'}
          to={RoutingEnum.contact}
          height={pxToRem(24)}
          width={pxToRem(24)}
          type={IconTypeEnum.contact}
        >
          <ContactIcon />
        </IconButton>
      </StyledNavbarGroup>
      <StyledSeparator />
      <StyledNavbarGroupRight>
        <BurgerMenu />
      </StyledNavbarGroupRight>
    </>
  )
}

NavBarMobile.propTypes = {}

export default NavBarMobile
